import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React, { useEffect, useState, useRef } from 'react';
import { Button } from '@ipc/ipc-components';
import { bindActionCreators } from 'redux';
import ListTable from '../../../../common/list-table/components/ListTable';
import TableDefinitions from '../../../../common/TableDefinitions';
import { getData, getEditDeviceSettingsLoading, getIsLoading } from '../redux/selectors/DeviceSettingsSelectors';
import { DeviceSettingsContainerStyle } from '../component/DeviceSettingsContainer.styles';
import { viewDeviceSettingsTableColumns, editDeviceSettingsTableColumns } from './DeviceSettingsTableColumns';
import { getUserRole } from '../../../../common/user/redux/selectors/UserSelectors';
import { editMrdSettingsRequestActionCreator } from '../redux/actions/DeviceSettingsActions';

function DeviceSettingsContainer(props) {
  const {
    isLoading,
    data,
    userRole,
    editDeviceSettings,
    editDeviceSettingsLoading,
  } = props;

  const [visibleData, setVisibleData] = useState(data);
  const [editMode, setEditMode] = useState(false);
  const [clickedRows, setClickedRows] = useState([]);
  const previousEditDeviceSettingsLoading = useRef(false);

  const viewColumns = viewDeviceSettingsTableColumns(visibleData);
  const editColumns = editDeviceSettingsTableColumns(visibleData, setVisibleData);
  const isUserIpcAdmin = userRole === 'IPC_ADMIN';

  let listTableProps;
  const getClickedRowsOnEdit = (state, rowInfo) => {
    if (rowInfo) {
      return {
        onClick: (e) => {
          if (e.target?.tagName === 'INPUT' && clickedRows.indexOf(rowInfo.original.id) === -1) {
            setClickedRows([...clickedRows, rowInfo.original.id]);
          }
        },
      };
    }
    return {};
  };

  if (editMode) {
    listTableProps = {
      columns: editColumns,
      getTrProps: getClickedRowsOnEdit,
    };
  } else {
    listTableProps = {
      columns: viewColumns,
      isDownloadEnable: true,
      downloadFileAs: 'DEVICE_SETTINGS',
      downloadFileTemplate: 'DEVICE_SETTINGS',
    };
  }

  const handleEditDeviceSettings = () => {
    const payload = visibleData.filter((row) => clickedRows.includes(row.id)).map((row) => ({
      deviceId: row.id,
      flightInfoButton: row.flightInfoButton === undefined ? null : row.flightInfoButton,
      manualEntryOption: row.manualEntryOption === undefined ? null : row.manualEntryOption,
      printFlightBarcode: row.printFlightBarcode === undefined ? null : row.printFlightBarcode,
      printStartStopBarcode: row.printStartStopBarcode === undefined ? null : row.printStartStopBarcode,
      ticketButton: row.ticketButton === undefined ? null : row.ticketButton,
    }));
    editDeviceSettings(payload);
  };

  const handleCloseEditMode = () => {
    setEditMode(false);
    setClickedRows([]);
  };
  const mapData = (rawData) => rawData.map((item) => {
    const downloadPrintFlightBarcode = item.printFlightBarcode ? 'YES' : 'NO';
    const downloadPrintStartStopBarcode = item.printStartStopBarcode ? 'YES' : 'NO';
    const downloadTicketButton = item.ticketButton ? 'YES' : 'NO';
    const downloadFlightInfoButton = item.flightInfoButton ? 'YES' : 'NO';
    const downloadManualEntryOption = item.manualEntryOption ? 'YES' : 'NO';

    return {
      ...item,
      downloadPrintFlightBarcode: item.printFlightBarcode !== undefined ? downloadPrintFlightBarcode : null,
      downloadPrintStartStopBarcode: item.printStartStopBarcode !== undefined ? downloadPrintStartStopBarcode : null,
      downloadTicketButton: item.ticketButton !== undefined ? downloadTicketButton : null,
      downloadFlightInfoButton: item.flightInfoButton !== undefined ? downloadFlightInfoButton : null,
      downloadManualEntryOption: item.manualEntryOption !== undefined ? downloadManualEntryOption : null,
    };
  });

  useEffect(() => {
    if (previousEditDeviceSettingsLoading.current && !editDeviceSettingsLoading) {
      handleCloseEditMode();
    }
    previousEditDeviceSettingsLoading.current = editDeviceSettingsLoading;
  }, [editDeviceSettingsLoading]);

  useEffect(() => { setVisibleData(mapData(data)); }, [data]);
  return (
    <DeviceSettingsContainerStyle>
      <div className={`device-settings-container edit-mode-${editMode}`}>
        <div className="mrd-settings-button-container">
          {isUserIpcAdmin && (
            editMode ? (
              <>
                <Button
                  onClick={handleEditDeviceSettings}
                  className={`primary-button-${clickedRows.length === 0} mrd-settings-button`}
                  disabled={clickedRows.length === 0}
                >
                  Save
                </Button>
                <Button
                  onClick={() => {
                    setVisibleData(data);
                    handleCloseEditMode();
                  }}
                  className="primary-button-false mrd-settings-button"
                >
                  Cancel
                </Button>
              </>
            ) : (
              <Button
                onClick={() => { setEditMode(true); }}
                className="primary-button-false mrd-settings-button"
              >
                Edit
              </Button>
            )
          )}
        </div>
        <ListTable
          listId={TableDefinitions.MRD_SETTINGS.id}
          loading={isLoading || editDeviceSettingsLoading}
          data={visibleData}
          {...listTableProps}
        />
      </div>
    </DeviceSettingsContainerStyle>
  );
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    isLoading: getIsLoading(state),
    userRole: getUserRole(state),
    editDeviceSettingsLoading: getEditDeviceSettingsLoading(state),
  };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  editDeviceSettings: editMrdSettingsRequestActionCreator,
}, dispatch);

DeviceSettingsContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  isLoading: PropTypes.bool,
  userRole: PropTypes.string,
  editDeviceSettings: PropTypes.func,
  editDeviceSettingsLoading: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(DeviceSettingsContainer);
